// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper_1AQovs","button":"button_3ZOCMn","notAvailable":"notAvailable_2vjr7K"};